import Backbone from 'backbone';
import template from './error-view-template.pug';

/**
 * AudienceCampaignErrorsView class that extends {Backbone.View} class
 * The view is mainly for displaying errors in the AudienceCampaign creation
 *
 * @class AudienceCampaignErrorsView
 * @extends {Backbone.View}
 */
export class AudienceCampaignErrorsView extends Backbone.View {
  /**
   * Initializes the {AudienceCampaignErrorsView} class.
   *
   * @returns {undefined}
   */
  initialize() {
    this.errors = [];
  }

  /**
   * Renders the view
   *
   * @returns {View} returns the view itself
   */
  render() {
    this.$el.html(template(this));

    return this;
  }

  /**
   * Set errors for the view to display
   *
   * @param {Object} errors - errors array
   *
   * @returns {undefined}
   */
  setErrors(errors) {
    this.errors = errors;

    this.render();
  }

  /**
   * Set single error message to display
   *
   * @param {string} errorMessage - error message
   *
   * @returns {undefined}
   */
  setErrorMessage(errorMessage) {
    this.errors = [
      {
        message: errorMessage,
      },
    ];

    this.render();
  }

  /**
   * Remove all the errors
   *
   * @returns {undefined}
   */
  removeErrors() {
    this.errors = [];

    this.render();
  }
}
